var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dateWrap"},[_c('div',[_vm._v(_vm._s(_vm.getDate[0]))]),_c('div',[_vm._v(_vm._s(_vm.getDate[1])+" "+_vm._s(_vm.getWeek))])])}
var staticRenderFns = []

export { render, staticRenderFns }